import React from "react";
import "./SidebarWidgets.css";

const SidebarWidgets = ({ title, Icon, activeTab }) => {
  return (
    <div
      className={`flex flex-col my-1 text-center sm:text-left text-white mx-auto sm:mx-1 cursor-pointer hover:bg-[#14B084] hover:rounded-2xl sidebarWidgets hover:duration-700 transition-transform ${
        activeTab === "true" && "sidebarWidget__active"
      }`}
    >
      <Icon className="sidebarWidgets__icons" />
      <h4 className="text-xs font-semibold mx-auto flex-grow sidebarWidgets__title">
        {title}
      </h4>
    </div>
  );
};

export default SidebarWidgets;
